/* eslint-disable no-sparse-arrays */
import Login from '../pages/membership/login';
import Signup from '../pages/membership/signup';
import ForgotPassword from '../pages/membership/forgotPassword';
import OnboardingStep2 from '../pages/onboarding/onboardingStep2';
// import OnboardingStep3 from '../pages/onboarding/onboardingStep3';
import Project from '../pages/project/allProjects';
import SelectWorkspace from '../pages/more/selectWorkspace';
import SignupJoin from '../pages/more/signupJoin';
import MyTask from '../pages/myTasks';
import RecurringTask from '../pages/recurring';
import Message from '../pages/message';
import Invoices from '../pages/invoices';
import InvoicesDetails from '../pages/invoices/invoiceDetails';
import Personal from '../pages/settings/personal/personalProfile';
import Email from '../pages/settings/personal/email';
import Password from '../pages/settings/personal/changePassword';
import Notification from '../pages/settings/personal/notifications';
import Tasks from '../pages/project/tasks';
import Files from '../pages/project/files';
import Overview from '../pages/project/overview';
import Payment from '../pages/settings/workspace/payment';
import Onboarding from '../pages/onboarding';
import MobileOnboarding from '../pages/onboarding/mobileOnboarding';
import Customer from '../pages/customer';
import TimeTracking from '../pages/timeTracking';
import Team from '../pages/settings/workspace/teams';
import Invoice from '../pages/settings/workspace/invoicing';
import { ROUTES } from './urls';
import Inbox from '../pages/inbox';
import AddNewInvoiceModal from '../pages/invoices/addNewInvoice/addNewInvoiceModal';
import NewInvoiceSecondStep from '../pages/invoices/addNewInvoice';
import Uninvoiced from '../pages/report/uninvoiced';
import Team_timeline from '../pages/report/teamTimeline';
import Project_timeline from '../pages/report/projectTimeline';
import Payments from '../pages/report/payments';
import ReportInvoice from '../pages/report/reportInvoice';
import Projects from '../pages/report/projects';
import Task from '../pages/report/tasks';
import Times from '../pages/report/time';
import Messages from '../pages/project/details/messages';
import CreateNewDoc from '../pages/project/files/createNewDoc';
import FileView from '../pages/project/files/fileView';
import ArchiveProject from '../pages/project/archiveProject';
import General from '../pages/settings/workspace/organizationProfile';
import ResetPassword from '../pages/membership/resetPassword';
import DetailsSetting from '../pages/project/details/setting';
import Milestone from '../pages/project/details/milestone';
import MembersOverviewDetails from '../pages/project/details/members/overview';
import MembersTaskDetails from '../pages/project/details/members/tasks';
import StripePayment from '../pages/settings/workspace/stripePayment';
import Subscription from '../pages/settings/workspace/subscription';
import Apps from '../pages/settings/workspace/apps';
import ApiKey from '../pages/settings/workspace/apiKeys';
import Integrations from '../pages/settings/workspace/integrations';
import FigmaConnectRedirect from '../pages/settings/workspace/redirectPages/figmaRedirect';
import DeleteUser from '../pages/membership/deleteUser';
import templates from '../pages/settings/workspace/templates';
import TemplateProjectDetails from '../pages/settings/workspace/templates/templateDetails';
import WorkspaceRedirect from '../pages/workspaceRedirect';
import Usage from '../pages/settings/workspace/usage';
import Snap from '../pages/snap';
import NavbarMessagesDetails from '../pages/message/messageDetails';
import MyTimelog from '../pages/myTimelog';
import TaskTemplateDetails from '../component/taskTemplateDetails';
import ResponsiveSearch from '../pages/responsiveSearch';
import GithubIntegration from '../pages/settings/workspace/integrations/githubIntegration';
import GithubCallback from '../pages/settings/workspace/integrations/githubIntegration/githubCallback';
import ReportNavbar from '../component/navbar/reportNavbar';
import SecurityAccess from '../pages/settings/personal/securityAccess';
import SentryCallback from '../pages/settings/workspace/integrations/sentryIntegration';
import SettingNavbar from '../component/navbar/settingNavbar';
import ResponsiveNavbar from '../pages/responsiveNavbar';
import ReferEarn from '../pages/settings/personal/referEarn';
import CustomerDetail from '../pages/customer/customerDetail';
import Views from '../pages/views';
import ViewDetails from '../pages/views/viewDetails';
import TaskDetailPage from '../pages/project/tasks/taskData';
import AIAgents from '../pages/settings/workspace/aiAgents';
import AiAgentDetails from '../pages/settings/workspace/aiAgents/aiAgentDetails';
import CreateProjectStep1 from '../pages/project/createProject';
import CreateProjectStep2 from '../pages/project/createProject/createProjectStep2.tsx';
import VercelIntegration from '../pages/settings/workspace/integrations/vercelIntegration';
import VercelAuth from '../pages/settings/workspace/integrations/vercelIntegration/vercelAuth';
import AllActivities from '../pages/project/overview/allActivities';
import TeamcampAi from '../pages/settings/workspace/teamcampAI';
import GoogleConnectRedirect from '../pages/membership/googleRedirect';
import WorkLoadPage from '../pages/report/workloadPage';

const router = [
  {
    path: ROUTES.LOGIN,
    component: Login,
    private: false
  },
  {
    path: ROUTES.SIGNUP,
    component: Signup,
    private: false
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    component: ForgotPassword,
    private: false
  },
  {
    path: ROUTES.DELETE_USER,
    component: DeleteUser,
    private: false
  },
  {
    path: ROUTES.WORKSPACE,
    component: Onboarding,
    private: true
  },
  {
    path: ROUTES.MOBILEONBOARDING,
    component: MobileOnboarding,
    private: true
  },

  {
    path: ROUTES.ONBOARDING_STEP2,
    component: OnboardingStep2,
    private: true
  },
  // {
  //   path: ROUTES.WELCOME,
  //   component: OnboardingStep3,
  //   private: true
  // },
  {
    path: ROUTES.MEMBERSHIP_INVITATION,
    component: SignupJoin,
    private: false
  },
  {
    path: ROUTES.SELECT_WORKSPACE,
    component: SelectWorkspace,
    private: true
  },
  {
    path: ROUTES.RESET_PASSWORD,
    component: ResetPassword,
    private: false
  },
  {
    path: ROUTES.GOOGLE_CONNECT_REDIRECT,
    component: GoogleConnectRedirect,
    private: false
  },
  // With Navbar
  {
    path: ROUTES.MYTASK,
    component: MyTask,
    private: true
  },
  {
    path: ROUTES.NAVBARMESSAGE,
    component: Message,
    private: true
  },
  {
    path: ROUTES.NAVBARMESSAGE_DETAILS_MOBILE,
    component: NavbarMessagesDetails,
    private: true
  },
  {
    path: ROUTES.SNAP,
    component: Snap,
    private: true
  },
  {
    path: ROUTES.INVOICES,
    component: Invoices,
    private: true
  },
  {
    path: ROUTES.INVOICE_DETAILS,
    component: InvoicesDetails,
    private: true
  },
  {
    path: ROUTES.ADD_NEW_INVOICES,
    component: AddNewInvoiceModal,
    private: true
  },
  {
    path: ROUTES.ADD_NEW_INVOICES_2,
    component: NewInvoiceSecondStep,
    private: true
  },
  {
    path: ROUTES.EDIT_INVOICES,
    component: NewInvoiceSecondStep,
    private: true
  },
  {
    path: ROUTES.ALL_PROJECT,
    component: Project,
    private: true
  },
  {
    path: ROUTES.CREATE_PROJECT,
    component: CreateProjectStep1,
    private: true
  },
  {
    path: ROUTES.CREATE_PROJECT_STEP2,
    component: CreateProjectStep2,
    private: true
  },
  {
    path: ROUTES.PROJECT_TASKS,
    component: Tasks,
    private: true
  },
  {
    path: ROUTES.PROJECT_FILES,
    component: Files,
    private: true
  },
  {
    path: ROUTES.PROJECT_FILE_VIEW,
    component: FileView,
    private: true
  },
  {
    path: ROUTES.PROJECT_MESSAGES,
    component: Messages,
    private: true
  },
  {
    path: ROUTES.PROJECT_OVERVIEW,
    component: Overview,
    private: true
  },
  {
    path: ROUTES.PROJECT_MILESTONE,
    component: Milestone,
    private: true
  },
  {
    path: ROUTES.PROJECT_DOCS,
    component: CreateNewDoc,
    private: true
  },
  {
    path: ROUTES.PROJECT_SETTING,
    component: DetailsSetting,
    private: true
  },
  {
    path: ROUTES.PERSONAL_SETTING,
    component: Personal,
    private: true
  },
  {
    path: ROUTES.EMAIL_SETTING,
    component: Email,
    private: true
  },
  {
    path: ROUTES.PASSWORD_SETTING,
    component: Password,
    private: true
  },
  {
    path: ROUTES.NOTIFICATION_SETTING,
    component: Notification,
    private: true
  },
  {
    path: ROUTES.SECURITY_ACCESS_SETTING,
    component: SecurityAccess,
    private: true
  },
  {
    path: ROUTES.GENERAL_SETTING,
    component: General,
    private: true
  },
  {
    path: ROUTES.AI_AGENTS_SETTING,
    component: AIAgents,
    private: true
  },
  {
    path: ROUTES.AI_AGENTS_SETTING_DETAILS,
    component: AiAgentDetails,
    private: true
  },
  {
    path: ROUTES.REFEREARN_SETTING,
    component: ReferEarn,
    private: true
  },
  {
    path: ROUTES.TEAMCAMP_AI,
    component: TeamcampAi,
    private: true
  },
  {
    path: ROUTES.USAGE_SETTING,
    component: Usage,
    private: true
  },
  {
    path: ROUTES.MEMBER_OVERVIEW,
    component: MembersOverviewDetails,
    private: true
  },
  {
    path: ROUTES.MEMBER_TASKS,
    component: MembersTaskDetails,
    private: true
  },
  {
    path: ROUTES.TEMPLATES_SETTING,
    component: templates,
    private: true
  },
  {
    path: ROUTES.TEMPLATES_SETTING_DETAILS,
    component: TemplateProjectDetails,
    private: true
  },
  {
    path: ROUTES.PAYMENT_SETTING,
    component: Payment,
    private: true
  },
  {
    path: ROUTES.PAYMENT_STRIPE_SETTING,
    component: StripePayment,
    private: true
  },
  {
    path: ROUTES.FIGMA_CONNECT_REDIRECT,
    component: FigmaConnectRedirect,
    private: true
  },
  {
    path: ROUTES.TEAM_SETTING,
    component: Team,
    private: true
  },
  {
    path: ROUTES.SUBSCRIPTION_SETTING,
    component: Subscription,
    private: true
  },
  {
    path: ROUTES.APPS_SETTING,
    component: Apps,
    private: true
  },
  {
    path: ROUTES.API_SETTING,
    component: ApiKey,
    private: true
  },
  {
    path: ROUTES.INTEGRATIONS_SETTING,
    component: Integrations,
    private: true
  },
  {
    path: ROUTES.INVOICE_SETTING,
    component: Invoice,
    private: true
  },
  {
    path: ROUTES.INBOX,
    component: Inbox,
    private: true
  },
  {
    path: ROUTES.CUSTOMER,
    component: Customer,
    private: true
  },
  {
    path: ROUTES.CUSTOMER_DETAILS,
    component: CustomerDetail,
    private: true
  },
  {
    path: ROUTES.TIMETRACKING,
    component: TimeTracking,
    private: true
  },
  {
    path: ROUTES.REPORT,
    component: ReportNavbar,
    private: true
  },
  {
    path: ROUTES.REPORT_PAYMENTS,
    component: Payments,
    private: true
  },
  {
    path: ROUTES.REPORT_UNINVOICED,
    component: Uninvoiced,
    private: true
  },
  {
    path: ROUTES.REPORT_INVOICE,
    component: ReportInvoice,
    private: true
  },
  {
    path: ROUTES.REPORT_PROJECTS,
    component: Projects,
    private: true
  },
  {
    path: ROUTES.REPORT_WORKLOAD,
    component: WorkLoadPage,
    private: true
  },
  {
    path: ROUTES.REPORT_TASK,
    component: Task,
    private: true
  },
  {
    path: ROUTES.REPORT_TEAM_TIMELINE,
    component: Team_timeline,
    private: true
  },
  {
    path: ROUTES.REPORT_PROJECTS_TIMELINE,
    component: Project_timeline,
    private: true
  },
  {
    path: ROUTES.REPORT_TIMES,
    component: Times,
    private: true
  },
  {
    path: ROUTES.ARCHIVE_PROJECT,
    component: ArchiveProject,
    private: true
  },
  {
    path: ROUTES.RECURRINGTASK,
    component: RecurringTask,
    private: true
  },
  {
    path: ROUTES.TASK_TEMPLATES_SETTING_DETAILS,
    component: TaskTemplateDetails,
    private: true
  },
  {
    path: ROUTES.SEARCH,
    component: ResponsiveSearch,
    private: true
  },
  {
    path: ROUTES.SETTING,
    component: SettingNavbar,
    private: true
  },
  {
    path: ROUTES.HOME,
    component: ResponsiveNavbar,
    private: true
  },
  {
    path: ROUTES.VIEWS,
    component: Views,
    private: true
  },
  {
    path: ROUTES.VIEW_ROUTE,
    component: ViewDetails,
    private: true
  },

  {
    path: ROUTES.WORKSPACE_REDIRECT,
    component: WorkspaceRedirect,
    private: true
  },
  {
    path: ROUTES.MY_TIMELOG,
    component: MyTimelog,
    private: true
  },
  {
    path: ROUTES.INTEGRATIONS_DETAILS,
    component: GithubIntegration,
    private: true
  },
  {
    path: ROUTES.GITHUB_CALLBACK,
    component: GithubCallback,
    private: true
  },
  {
    path: ROUTES.VERCEL_INTEGRATION_DETAILS,
    component: VercelIntegration,
    private: true
  },
  {
    path: ROUTES.TASK_DETAILS,
    component: TaskDetailPage,
    private: true
  },
  {
    path: ROUTES.SENTRY_CALLBACK,
    component: SentryCallback,
    private: true
  },
  {
    path: ROUTES.ALL_ACTIVITIES,
    component: AllActivities,
    private: true
  },
  {
    path: ROUTES.VERCEL_AUTH,
    component: VercelAuth,
    private: true
  }
];

export default router;
